import {api as eventApi} from '~/CreateFabricInvitation/api/api';
import {api as checkoutApi} from '~/common/checkout/api/api';
import {controllersReducer} from '~/common/event/controllers/reducer';
import {eventAttributesReducer} from '~/common/event/eventAttributes/reducer';
import {api as guestsApi} from '~/common/fabric/EventGuests/api/api';
import {reducer as guests} from '~/common/fabric/EventGuests/reducers/guests/reducer';
import {unlockedStepsReducer} from '~/common/fabric/reducers/createFlowNav/reducer';
import {reducer as details} from '~/common/fabric/reducers/details/reducer';
import {reducer as eviteEvent} from '~/common/fabric/reducers/eviteEvent/reducer';
import {reducer as giftingOptions} from '~/common/fabric/reducers/giftingOptions/reducer';
import {reducer as guestOptions} from '~/common/fabric/reducers/guestOptions/reducer';
import {reducer as review} from '~/common/fabric/reducers/review/reducer';
import {reducer as widgets} from '~/common/fabric/reducers/widgets/reducer';
import {reducer as snapshot} from '~/common/fabric/Snapshot/reducers';
import {reducer as user} from '~/common/fabric/User/reducers/user/reducer';
import {cachedMediaReducer} from '~/common/reducers/cachedMedia';
import {api as oneStepApi} from '~/OneStepCreateInvitation/api/api';
import {api as viewInvitationApi} from '~/ViewInvitation/api/api';
import {reducer as donation} from '~/ViewInvitation/reducers/donation';
import {reducer as photos} from '~/ViewInvitation/reducers/photos';
import {reducer as loginModal} from '~library/organisms/LoginModal/reducer';
import {reducer as fabricDesign} from './fabricDesign/reducer';
import {reducer as fabricTemplate} from './fabricTemplate/reducer';
import {reducer as modals} from './modals/reducer';
import {previewReducer} from './preview/reducer';
import {reducer as webview} from './webview/reducer';

export const rootReducer = {
  [eventApi.reducerPath]: eventApi.reducer,
  controllers: controllersReducer,
  [oneStepApi.reducerPath]: oneStepApi.reducer,
  [viewInvitationApi.reducerPath]: viewInvitationApi.reducer,
  [guestsApi.reducerPath]: guestsApi.reducer,
  [checkoutApi.reducerPath]: checkoutApi.reducer,
  eventAttributes: eventAttributesReducer,
  unlockedStepsReducer,
  details,
  fabricDesign,
  fabricTemplate,
  giftingOptions,
  guestOptions,
  guests,
  loginModal,
  eviteEvent,
  user,
  review,
  modals,
  preview: previewReducer,
  webview,
  widgets,
  snapshot,
  cachedMedia: cachedMediaReducer,
  // for invitation preview
  donation,
  photos,
  moduleOrder: (state = {}) => state,
  eventDetails: (state = {}) => state,
  coverData: (state = {}) => state,
  rsvp: (state = {}) => state,
  gifting: (state = {}) => state,
  registry: (state = {}) => state,
  poll: (state = {}) => state,
  giftKeywords: (state = {}) => state,
  whatToBring: (state = {}) => state,
  whatToBringSummary: (state = {}) => state,
  guestList: (state = {}) => state,
  whoIsComing: (state = {}) => state,
  premiumDesign: (state = {}) => state,
};
